"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pdfStyles = exports.colors = void 0;
var colors = {
  primaryColor: '#0072CF',
  lightPrimaryColor: '#eaf6fb',
  lightGray: '#F5F5F4',
  darkGray: '#AAA',
  black: '#000000'
};
exports.colors = colors;
var pdfStyles = {
  title: {
    fontSize: 16,
    color: colors.primaryColor,
    bold: true
  },
  noDataAvailable: {
    fontSize: 12,
    bold: true,
    margin: [0, 2, 0, 2] // left, top, right, bottom

  },
  stackRow: {
    margin: [0, 2, 0, 2]
  },
  messageBox: {
    fillColor: colors.lightPrimaryColor
  },
  datumSpan: {
    margin: [0, 0, 0, 10]
  },
  footnote: {
    bold: false,
    fontSize: 8,
    margin: [0, 0, 0, 0]
  },
  underText: {
    bold: false,
    fontSize: 8
  },
  spaceBetween: {
    margin: [0, 10, 0, 0]
  },
  investmentOptionLabel: {
    bold: true,
    fontSize: 11
  },
  borderColor: {
    color: colors.lightGray
  },
  my529Logo: {
    margin: [35, 0, 0, 5]
  }
};
exports.pdfStyles = pdfStyles;